import Vue from 'vue'

import CadastroAdministrativoEmpresa from './administrativo/empresa/Cadastro.vue'

import MasterPage from './shared/MasterPage.vue'
import RelatorioPage from './shared/RelatorioPage.vue'
import AlterarSenha from './shared/AlterarSenha.vue'
import LoginAdministrativo from './administrativo/login/Login.vue'

import PieChart from './shared/charts/PieChart.vue'
import DoughnutChart from './shared/charts/DoughnutChart.vue'
import BarChart from './shared/charts/BarChart.vue'
import StackBarChart from './shared/charts/BarChart2.vue'
import FunelChart from './shared/charts/FunelChart.vue'
import Mapa from './shared/Mapa.vue'

import FiltroRecebivel from '../router/relatorio/recibodoador/FiltroRecebivel.vue'

import ListPage from './shared/ListPage.vue'
import CadastroFornecedor from './financeiro/fornecedor/Cadastro.vue'
import CadastroOrcamento from './financeiro/orcamento/Cadastro.vue'
import CadastroBanco from './financeiro/banco/Cadastro.vue'
import CadastroFechamentoMes from './financeiro/fechamentomes/Cadastro.vue'
import CadastroCompromisso from './financeiro/compromisso/Cadastro.vue'
import CadastroRecebivel from './financeiro/recebivel/Cadastro.vue'
import GerarRecebivel from './financeiro/recebivel/Gerar.vue'
import RetornoRecebivel from './financeiro/recebivel/Retorno.vue'
import CadastroPlanoContaContabil from './financeiro/planocontacontabil/Cadastro.vue'
import CadastroFluxoBancario from './financeiro/fluxobancario/Cadastro.vue'
import CadastroConciliacaoBancaria from './financeiro/conciliacaoBancaria/Cadastro.vue'
import TransferenciaBancaria from './financeiro/fluxobancario/Transferencia.vue'
import CadastroRegiao from './doacao/regiao/Cadastro.vue'
import CadastroRelacionamento from './doacao/relacionamento/Cadastro.vue'
import CadastroOportunidade from './doacao/oportunidade/Cadastro.vue'
import CadastroDoador from './doacao/doador/Cadastro.vue'

import CadastroBeneficiario from './projetos/beneficiario/Cadastro.vue'

import CadastroTipoProjeto from './projetos/tipoprojeto/Cadastro.vue'
import CadastroPessoal from './projetos/pessoal/Cadastro.vue'
import CadastroProjeto from './projetos/projeto/Cadastro.vue'
import CadastroFluxoBancarioExtrato from './projetos/monitoramento/fluxobancario/Cadastro.vue'
import CadastroMonitoramentoAtividade from './projetos/monitoramento/atividade/Cadastro.vue'
import CadastroMonitoramentoIndicador from './projetos/monitoramento/indicador/Cadastro.vue'
import CadastroUsuario from './auxiliar/usuario/Cadastro'

import CadastroNFSe from './fiscal/nfse/Cadastro'
import GerarNFSe from './fiscal/nfse/Gerar'

import Info from './shared/Info.vue'

Vue.component('cadastro-administrativo-empresa', CadastroAdministrativoEmpresa);

Vue.component('master-page', MasterPage);
Vue.component('relatorio-page', RelatorioPage);
Vue.component('alterar-senha', AlterarSenha);
Vue.component('login-administrativo', LoginAdministrativo);

Vue.component('pie-chart', PieChart);
Vue.component('doughnut-chart', DoughnutChart);
Vue.component('bar-chart', BarChart);
Vue.component('bar-chart2', StackBarChart);
Vue.component('funel-chart', FunelChart);
Vue.component('mapa', Mapa);

Vue.component('filtro-recebivel', FiltroRecebivel);

Vue.component('list-page', ListPage);
Vue.component('cadastro-banco', CadastroBanco);
Vue.component('cadastro-fornecedor', CadastroFornecedor);
Vue.component('cadastro-orcamento', CadastroOrcamento);
Vue.component('cadastro-recebivel', CadastroRecebivel);
Vue.component('gerar-recebivel', GerarRecebivel);
Vue.component('retorno-recebivel', RetornoRecebivel);
Vue.component('cadastro-compromisso', CadastroCompromisso);
Vue.component('cadastro-fechamentomes', CadastroFechamentoMes);
Vue.component('cadastro-planocontacontabil', CadastroPlanoContaContabil);
Vue.component('cadastro-fluxobancario', CadastroFluxoBancario);
Vue.component('cadastro-conciliacaoBancaria', CadastroConciliacaoBancaria);
Vue.component('transferencia-bancaria', TransferenciaBancaria);
Vue.component('cadastro-regiao', CadastroRegiao);
Vue.component('cadastro-relacionamento', CadastroRelacionamento);
Vue.component('cadastro-oportunidade', CadastroOportunidade);
Vue.component('cadastro-doador', CadastroDoador);
Vue.component('cadastro-beneficiario', CadastroBeneficiario);
Vue.component('cadastro-tipo-projeto', CadastroTipoProjeto);
Vue.component('cadastro-pessoal', CadastroPessoal);
Vue.component('cadastro-projeto', CadastroProjeto);
Vue.component('cadastro-fluxobancario-extrato', CadastroFluxoBancarioExtrato);
Vue.component('cadastro-monitoramento-atividade', CadastroMonitoramentoAtividade);
Vue.component('cadastro-monitoramento-indicador', CadastroMonitoramentoIndicador);
Vue.component('cadastro-usuario', CadastroUsuario);

Vue.component('info', Info);

Vue.component('cadastro-nfse', CadastroNFSe);
Vue.component('gerar-nfse', GerarNFSe);